import React, { useState, useEffect } from 'react';
import { PICKUP_POLICY_STATUS, SKELETON_ROWS } from '../constants';
import PickupPolicyDetails from './PickupPolicyDetails';
import PickupPolicyForm from './PickupPolicyForm';
import Button from '../../../../../components/ComponentsV1/Button';
import { Skeleton } from '../../../../../components/ComponentsV1/Skeleton/Skeleton';

const PolicySkeleton = () => (
  <div className='tw-bg-white tw-p-8 tw-rounded-2xl'>
    <Skeleton rows={SKELETON_ROWS} />
  </div>
);

const PickupPolicyResult = ({
  policyStatus,
  policyData,
  isFetching,
  isActionLoading,
  operatorsMap,
  operators,
  attributeValues,
  onUpdate,
  onCreate,
}) => {
  const [isFormMode, setIsFormMode] = useState(false);

  useEffect(() => {
    setIsFormMode(false);
  }, [policyStatus, policyData]);

  if (policyStatus === PICKUP_POLICY_STATUS.NONE) {
    if (isFetching) return <PolicySkeleton />;
    return null;
  }

  if (isActionLoading) {
    return <PolicySkeleton />;
  }

  // CASE: Policy exists
  if (policyStatus === PICKUP_POLICY_STATUS.EXISTS) {
    return (
      <div className='tw-bg-white tw-p-8 tw-rounded-2xl tw-flex tw-flex-col tw-gap-6'>
        <div className='tw-flex tw-items-center tw-gap-2 tw-text-[1.6rem] tw-font-medium tw-text-green-700'>
          Policy exists
        </div>

        <PickupPolicyDetails policyData={policyData} operatorsMap={operatorsMap} />

        {!isFormMode && (
          <div className='tw-flex tw-flex-col tw-gap-3'>
            <div className='tw-text-[1.2rem] tw-text-zinc-500 tw-font-medium'>
              Update will modify the existing pickup policy.
              <br />
              Choose your action carefully as this is going to affect the entire pickup flow.
            </div>
            <div className='tw-flex tw-gap-4'>
              <Button title='Update' onClick={() => setIsFormMode(true)} />
            </div>
          </div>
        )}

        {isFormMode && (
          <PickupPolicyForm
            operators={operators}
            attributeValues={attributeValues}
            initialPolicy={policyData?.pickup_policy}
            loading={isActionLoading}
            onSubmit={(pickupPolicy) => {
              onUpdate(pickupPolicy);
            }}
            onCancel={() => setIsFormMode(false)}
          />
        )}
      </div>
    );
  }

  // CASE: Policy does not exist
  if (policyStatus === PICKUP_POLICY_STATUS.NOT_FOUND) {
    return (
      <div className='tw-bg-white tw-p-8 tw-rounded-2xl tw-flex tw-flex-col tw-gap-6'>
        <div className='tw-flex tw-items-center tw-gap-2 tw-text-[1.6rem] tw-font-medium tw-text-zinc-700'>
          Policy does not exist. You can create a new one.
        </div>

        {!isFormMode && (
          <div className='tw-mt-2'>
            <Button title='Create Policy' onClick={() => setIsFormMode(true)} />
          </div>
        )}

        {isFormMode && (
          <PickupPolicyForm
            operators={operators}
            attributeValues={attributeValues}
            initialPolicy={null}
            loading={isActionLoading}
            onSubmit={(pickupPolicy) => {
              onCreate(pickupPolicy);
            }}
            onCancel={() => setIsFormMode(false)}
          />
        )}
      </div>
    );
  }

  return null;
};

export default PickupPolicyResult;
